import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import RemoveLineup from './components/remove-lineup';
import CheckLineup from './components/check-lineup';
import {Factory as LineupPlayersFactory} from './components/mobile/lineup-players/factory';
import {Factory as LineupDetailsFactory} from './components/mobile/lineup-details/factory';

class Lineup extends Component {
    render() {
        const {sportConfig, lineups, lineupId, index} = this.props;

        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const LineupPlayers = LineupPlayersFactory.getComponent(sportConfig);

        return (
            <div className="table-holder" key={lineupId}>
                <div className="gray-box">
                    <div className="pull-left">
                        <CheckLineup lineupId={lineupId} />
                        <span>L{1 + index}</span>
                    </div>
                    <div className="actions-holder">
                        <RemoveLineup lineupId={lineupId}>
                            <i className="fa fa-trash"></i>
                        </RemoveLineup>
                    </div>
                </div>

                <div className="lineup-box">
                    <LineupPlayers lineupId={lineupId} />
                </div>

                <div className="gray-box">{LineupDetailsFactory.getContent(sportConfig, lineup)}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        sportConfig,
    } = state;
    return {
        lineups,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(Lineup);
